module.exports = __webpack_public_path__ + "static/media/Pimkart.143c274c.svg";